import type { ConsumableGetAllResponse } from '@quromedical/models';
import {
  type ConsumableTableData,
  consumableColumns,
  getDataFromResponse,
} from 'core/consumable';
import { PaginatedTable } from 'core/table';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { ConsumableApi } from 'integration/aggregate';
import type React from 'react';
import { useCallback } from 'react';

interface ConsumableTableProps {
  patientId: string;
}

const api = new ConsumableApi();

export const ConsumableTable: React.FC<ConsumableTableProps> = ({
  patientId,
}) => {
  const fetcher = useCallback(
    (options?: FetcherOptions) =>
      api.getConsumables({
        patientId,
        pageToken: options?.nextToken,
        count: options?.count,
      }),
    [patientId],
  );
  const swrKey = patientId;

  return (
    <PaginatedTable<Partial<ConsumableTableData>, ConsumableGetAllResponse>
      cacheKey={swrKey}
      fetcher={fetcher}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      columns={consumableColumns}
      showHeader={true}
      getDataFromResponse={getDataFromResponse}
      canChangeCount
    />
  );
};
